<template>
  <div class="edit-platform">
    <div class="breadcrumb" style="background: #fff">申请提现</div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" ref="rules" label-width="140px" class="demo-ruleForm">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.store.code }}</span>
        </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.store.name }} </el-form-item>
        <el-form-item label="业务:"> {{ basicInfo.store.salesman.fullName }} </el-form-item>
        <el-form-item label="提现金额:"> {{ Math.floor(basicInfo.totalAmount * 100) / 100 }} </el-form-item>
        <el-form-item label="实际提现金额:"> {{ basicInfo.amount }} </el-form-item>
        <el-form-item label="收款账户:"> {{ bankInfo.accountName }} </el-form-item>
        <el-form-item label="账户号:"> {{ bankInfo.collectionAccount }} </el-form-item>
        <el-form-item label="开户行:"> {{ bankInfo.bank }} </el-form-item>
        <el-form-item label="申请日期:"> {{ basicInfo.dateCreated }} </el-form-item>
        <el-form-item label="打款日期:" v-if="basicInfo.paymentDate"> {{ basicInfo.paymentDate }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button" v-if="handleType === 'audit'">
      <el-button round style="width: 100px" @click="checkType = false, checkDialog = true">审核拒绝</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="checkType = true, checkDialog = true">审核通过</el-button>
    </div>
    <div class="edit-button" v-if="handleType === 'invoice'">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="invoice">已收发票</el-button>
    </div>
    <div class="edit-button" v-if="handleType === 'cashout'">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="cashout">打款</el-button>
    </div>
    <div class="edit-button" v-if="handleType === ''">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="back">返回</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <span>{{ checkType ? '是否确认审核通过？' : '是否确认审核拒绝？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handleCashout } from '@/api/epay'
import { getByStoreId } from '@/api/crm'
export default {
  name: 'audit',
  data () {
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      handleType: '',
      basicInfo: {
        store: {
          salesman: {

          }
        },
        accountBalance: {
        }
      },
      bankInfo: {}
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    let id = JSON.parse(this.$route.query.rowDate).store.id
    // let id = 190086
    getByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.sendFlag = obj.sendFlag === undefined ? '1' : obj.sendFlag
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        this.bankInfo = obj
      } else {

      }
    })
    if (this.$route.query.rowDate) {
      this.basicInfo = JSON.parse(this.$route.query.rowDate)
      this.handleType = this.$route.query.handleType
    }
  },
  methods: {
    check () {
      // console.log(this.basicInfo)
      let auditVo = {
        action: this.checkType ? 'audit' : 'reject',
        refundId: this.basicInfo.refundId
      }
      handleCashout(auditVo).then(res => {
        if (res.data.success) {
          this.$message.success('审核成功')
          this.checkDialog = false
          this.$router.go(-1)

          // if (this.checkType) {
          //   this.storeMsg = res.data.data
          //   this.checkTrueDialog = true
          // } else {
          //   this.$router.go(-1)
          // }
        }
      })
    },
    back () {
      this.$router.go(-1)
    },
    invoice () {
      let auditVo = {
        action: 'invoice',
        refundId: this.basicInfo.refundId
      }
      handleCashout(auditVo).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      })
    },
    cashout () {
      let auditVo = {
        action: 'cashout',
        refundId: this.basicInfo.refundId
      }
      handleCashout(auditVo).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";
</style>
